import React, { useEffect, useState } from "react";
import {
  documentDownloaded,
  downloadDocument,
  getDownloadedDocumentData,
} from "../store/documents";
import { useDispatch, useSelector } from "react-redux";
import { getAlert } from "../../Services/appAlerts";

const useDocDownload = () => {
  const [doc, setDoc] = useState(null);
  const [downloadingDocId, setDownloadingDocId] = useState(null);
  const downloadedDocumentDataSelector = useSelector(getDownloadedDocumentData);

  const dispatch = useDispatch();
  const handleDownloadFile = async (item) => {
    const docId = item.docId || item.id;
    setDownloadingDocId(docId);
    dispatch(downloadDocument(docId));
    setDoc(item);

    // Safety timeout to clear loading indicator if request fails
    setTimeout(() => {
      setDownloadingDocId((prev) => (prev === docId ? null : prev));
    }, 8000);
  };

  useEffect(() => {
    console.log(
      "downloadedDocumentDataSelector",
      downloadedDocumentDataSelector,
    );
    if (downloadedDocumentDataSelector?.uploadUrl && doc) {
      try {
        window.open(downloadedDocumentDataSelector.uploadUrl, "_blank");
        dispatch(documentDownloaded(null));
      } catch (error) {
        getAlert("", error?.message, "error");
      } finally {
        setDownloadingDocId(null);
        setDoc(null);
      }
    }
  }, [downloadedDocumentDataSelector, doc, dispatch]);

  return [handleDownloadFile, downloadingDocId];
};

export default useDocDownload;
